import { UseBoolean } from '@aibees/shared/hooks';

export interface HeaderNavigationProps {
  className?: string;
  drawerState?: UseBoolean;
}

export enum Navigation {
  NEXT = 1,
  PREV = -1,
}
